var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavArrowOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 158,
    viewBox: "0 0 87 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4351 157.5C45.1051 157.5 22.7651 157.5 0.43512 157.5C0.43512 154.83 0.43512 152.17 0.43512 149.5C0.43512 99.83 0.43512 50.17 0.43512 0.5C22.7651 0.5 45.1051 0.5 67.4351 0.5C77.8951 3.13 84.0551 9.79 85.9351 20.5C86.4351 60.17 86.6051 99.83 86.4351 139.5C83.3051 148.96 76.9751 154.96 67.4351 157.5Z",
    fill: "#FDFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4346 113.5C26.1246 113.36 23.9546 110.69 24.9346 105.5C33.7646 96.67 42.6046 87.83 51.4346 79C42.6046 70.17 33.7646 61.33 24.9346 52.5C23.2646 46.51 25.4346 44.01 31.4346 45C42.6746 55.74 53.3446 66.91 63.4346 78.5C62.8446 80.27 62.0146 81.93 60.9346 83.5C50.8546 93.42 41.0146 103.42 31.4346 113.5Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrowOut);
export default __webpack_public_path__ + "static/media/navArrowOut.68d090f97a513977f3d632ac0a1c5f4f.svg";
export { ForwardRef as ReactComponent };